import React, { useState } from "react";
import "../../styles/LegalPages.css";

export default function DeleteAccount() {
const [email, setEmail] = useState("");
const [submitted, setSubmitted] = useState(false);

const handleSubmit = (e) => {
e.preventDefault();


const subject = encodeURIComponent(
  "Victoria Sports Club App - Account Deletion Request"
);

const body = encodeURIComponent(
  `Hello Victoria Sports Club Team,


I would like to request deletion of my Victoria Sports Club mobile app account and associated personal information.

Account email: ${email}

Please let me know if you need additional information to verify my identity.

Thank you.`
);


window.location.href =
  `mailto:web.vsmarketing@gmail.com?subject=${subject}&body=${body}`;

setSubmitted(true);


};

return ( <main className="legal-page"> <section className="legal-hero"> <p className="legal-label">Victoria Sports Club</p> <h1>Request Account Deletion</h1> <p>
You can request deletion of your Victoria Sports Club mobile app
account and associated personal information using this page. </p> </section>


  <section className="legal-card">
    {submitted ? (
      <>
        <h2>Continue Your Request</h2>
        <p>
          Your email application should open with a prepared deletion
          request. Please send that email to submit your request to our
          team.
        </p>
        <p>
          If your email application did not open, send your request
          directly to{" "}
          <a href="mailto:web.vsmarketing@gmail.com">
            web.vsmarketing@gmail.com
          </a>
          .
        </p>
        <p>
          Your account has not been deleted just by submitting this form.
          Our team may contact you to verify your identity before
          processing your request.
        </p>
      </>
    ) : (
      <>
        <h2>How Account Deletion Works</h2>
        <p>
          Complete the form below to prepare an account deletion request.
          Your email application will open so you can send the request
          directly to our team.
        </p>

        <ul>
          <li>
            We may verify your identity before processing the request.
          </li>
          <li>
            We will review eligible requests within a reasonable period
            and in accordance with applicable laws.
          </li>
          <li>
            Information required by law or for legitimate recordkeeping
            may need to be retained.
          </li>
          <li>
            Submitting a request does not immediately delete your account.
          </li>
        </ul>

        <form onSubmit={handleSubmit}>
          <label htmlFor="account-email">
            Email address associated with your account
          </label>

          <input
            id="account-email"
            name="email"
            type="email"
            autoComplete="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Enter your account email"
            required
            style={{
              display: "block",
              width: "100%",
              boxSizing: "border-box",
              padding: "12px",
              marginTop: "10px",
              marginBottom: "20px",
              border: "1px solid #ccc",
              borderRadius: "8px",
              fontSize: "15px",
            }}
          />

          <button
            type="submit"
            style={{
              background: "#123a29",
              color: "#fff",
              padding: "13px 22px",
              border: "none",
              borderRadius: "8px",
              fontSize: "15px",
              fontWeight: 700,
              cursor: "pointer",
            }}
          >
            Prepare Deletion Request
          </button>
        </form>

        <p style={{ marginTop: "24px" }}>
          Prefer to email us directly? Contact{" "}
          <a href="mailto:web.vsmarketing@gmail.com">
            web.vsmarketing@gmail.com
          </a>
          .
        </p>

        <p>
          See our{" "}
          <a href="/privacy-policy">Privacy Policy</a> for more information
          about how we handle personal information.
        </p>
      </>
    )}
  </section>
</main>


);
}
